export var INIT_LOADER_SHOWING = 'INIT_LOADER_SHOWING';
export var LOADER_SHOW = 'LOADER_SHOW';
export var INIT_LOADER_HIDING = 'INIT_LOADER_HIDING';
export var HIDE_LOADER = 'HIDE_LOADER';
export var INIT_REQUEST_COUNTER_INCREASING = 'INIT_REQUEST_COUNTER_INCREASING';
export var REQUEST_COUNTER_INCREASE = 'REQUEST_COUNTER_INCREASE';
export var INIT_REQUEST_COUNTER_DECREASING = 'INIT_REQUEST_COUNTER_DECREASING';
export var REQUEST_COUNTER_DECREASE = 'REQUEST_COUNTER_DECREASE';